import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Response} from '@angular/http';
import {Service} from '../../../domain/model/common/service.class';
import {SectionService} from '../../../domain/model/common/section-service.class';
import {Model} from '../../../domain/model/common/model.class';
import {ReleaseAuthorizationInfo} from './release-authorization-info.model';

const CURRENT_USER_PATH = 'currentUser';

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
@Injectable()
export class ReleaseSectionService extends SectionService {

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'release');
    }

    currentUserReleaseAuthorizationInfo(): Observable<ReleaseAuthorizationInfo | undefined> {
        return this.getForCurrentUser(ReleaseAuthorizationInfo);
    }

    updateCurrentUserReleaseAuthorizationInfo(info: ReleaseAuthorizationInfo): Observable<Response> {
        return this.updateForCurrentUser(info);
    }

    private getForCurrentUser<T extends Model<T>>(type: Model.Type<T>): Observable<T> {
        return this.get(type, CURRENT_USER_PATH);
    }

    private updateForCurrentUser(model: Model<any>): Observable<Response> {
        return this.update(model, CURRENT_USER_PATH);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/release/model/release-section.service.ts